export const getRoomOptions = (maxRooms: number) => {
  return Array(Math.min(maxRooms, 4))
    .fill(0)
    .map((_, index: number) => ({
      label: (index + 1).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
      value: index + 1,
    }))
}

export const getPeopleOptions = (maxPeople: number, minPeople: number) => {
  return Array(maxPeople - minPeople + 1)
    .fill(0)
    .map((_, index: number) => ({
      label: (index + minPeople).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
      value: index + minPeople,
    }))
}
